import React, { useState, useEffect } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

import ModalWrapper from 'components/ChannelView/ModalWrapper'
import CheckField from '../../CheckField'

import { lang } from 'utils/helpers'

import './styles.scss'

const THeaderConfigPopUp = ({ fields, onChange, isOpen, onClose }) => {
  const [fieldList, setFieldList] = useState(fields)
  const [fieldSelect, setFieldSelect] = useState([])
  const lists = ['left', 'right']
  const [elements, setElements] = useState({})

  useEffect(() => {
    const lengthColsShowName = fieldList.length
    getFieldsSelect()
    createListElements(lengthColsShowName, fieldList)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getFieldsSelect = () => {
    const fieldsSel = []
    for( const { value, isSelected } of fields){
      if(isSelected) fieldsSel.push(value)
    }
    setFieldSelect(fieldsSel)
  }


  const createListElements = (tam, newOrderElement) => {
    let listsElements = {
      left:[],
      right:[]
    }
    for ( let i = 0 ; i < tam; i++){
      if(i < Math.ceil(tam / 2))
        listsElements.left.push(newOrderElement[i])
      else
        listsElements.right.push(newOrderElement[i])
    }
    setElements({ ...listsElements })
  }

  const removeFromList = (list, index) => {
    const result = Array.from(list)
    const [removed] = result.splice(index, 1)
    return [removed, result]
  }

  const addToList = (list, index, element) => {
    const result = Array.from(list)
    result.splice(index, 0, element)
    return result
  }

  const locationElements = (listCopy) => {
    if(listCopy.left.length > Math.round(fields.length/2)){
      const el = listCopy.left[listCopy.left.length-1]
      listCopy.left.pop()
      listCopy.right.unshift(el)
    }

    if(listCopy.right.length > Math.round(fields.length/2)){
      const el = listCopy.right[0]
      listCopy.right.shift()
      listCopy.left.push(el)
    }
    setElements(listCopy)
    return [...listCopy.left, ...listCopy.right]
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    const listCopy = { ...elements }

    const sourceList = listCopy[result.source.droppableId]
    const [removedElement, newSourceList] = removeFromList(
      sourceList,
      result.source.index
    )

    listCopy[result.source.droppableId] = newSourceList
    const destinationList = listCopy[result.destination.droppableId]

    listCopy[result.destination.droppableId] = addToList(
      destinationList,
      result.destination.index,
      removedElement
    )

    const ordersElements = locationElements(listCopy)
    setFieldList(ordersElements)
  }

  const checkCol = (element) => {
    const index = fieldList.indexOf(element)
    const list = fieldList
    list[index].isSelected = !element.isSelected
    setFieldList(list)
    createListElements(list.length, list)
  }

  const onUpdate = () => {
    const newOrder = []
    for(const { isSelected, value } of fieldList){
      if(isSelected) newOrder.push(value)
    }
    if (newOrder.join() !== fieldSelect.join()){
      onChange(newOrder)
    }
    onClose()
  }

  return (
    <div className='modal-reorder-column'>
      <ModalWrapper
        id='modalColumn_THeaderConfigPopUp'
        header=''
        body={
          <>
            <h3><strong>{lang('header_THeaderConfigPopUp')}</strong></h3>
            <div style={{ marginTop:20 }}>
              <div>
                <DragDropContext
                  onDragEnd={onDragEnd}
                >
                  <div className='listGridDrag'>
                    {lists.map((listKey, index)=>(
                      <div key={index}>
                        <Droppable droppableId={`${listKey}`}>
                          {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                              {elements[listKey].map((element, idx)=>(
                                <Draggable key={element.value} draggableId={element.value} index={idx}>
                                  {(provided, snapshot) =>(
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className='columnContentTable'
                                    >
                                      <div className={`columnItemOrder ${element.isSelected&&'activeColumnOrder'}`}>
                                        <CheckField isChecked={element.isSelected} action={() => checkCol(element)} />
                                        <span className='labelColumn'>{lang(element.key)}</span>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </div>
                    ))}
                  </div>
                </DragDropContext>
              </div>
            </div>
            <button color='secondary' className='btnApply' onClick={onUpdate}>
              {lang('dashboard_apply')}
            </button>
          </>
        }
        isOpen={isOpen}
        toggle={onClose}
        showClose={true}/>
    </div>

  )
}

export default THeaderConfigPopUp